module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box red"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "btn btn-circle btn-default",
    attrs: {
      "to": "/inbox"
    }
  }, [_c('i', {
    staticClass: "icon-envelope-open"
  }), _vm._v("\n\t\t\t\tIr para Caixa de Entrada\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, _vm._l((_vm.messagesGroups), function(msgGroup) {
    return _c('div', {
      staticClass: "portlet m-b-0"
    }, [_c('div', {
      staticClass: "portlet-title m-b-0"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('i', {
      staticClass: "icon-speech"
    }), _vm._v(" "), _c('span', {
      staticClass: "caption-subject bold uppercase"
    }, [_vm._v("\n\t\t\t\t\t\tAssunto: " + _vm._s(msgGroup.subject) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('button', {
      staticClass: "btn btn-circle btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.replyMessage(msgGroup.messageGroup)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tResponder\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "portlet-body p-t-0"
    }, [_c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-condensed table-striped"
    }, [_c('tbody', _vm._l((msgGroup.messages), function(msg, index) {
      return (index < 3) ? _c('tr', [_c('td', {
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(msg.from.name))]), _vm._v(" "), _c('td', {
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(_vm._f("truncate")(msg.message, 340)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right",
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(_vm._f("date")(msg.sentDateTime, "DD/MM/YYYY HH:mm")))])]) : _vm._e()
    }))])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-envelope-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\tMensagens não lidas\n\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a31e356e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/highlight/messages/main.vue
// module id = 1099
// module chunks = 1